// extracted by mini-css-extract-plugin
export default {"-large":"Bbz6B7HBP_Pt5kjGlCCo","container":"IDyftBUSp1kKkU2eMZnO"};